/**
 * Thin wrappers around browser navigation. Components call these instead of
 * touching `window.location` / `window.open` directly so they stay unit-testable
 * — jsdom forbids stubbing `window.location`.
 */
export function redirectTo(url: string): void {
  window.location.href = url;
}

export function openInNewTab(url: string): void {
  window.open(url, '_blank');
}
